.trigger {
  padding: 0;
  border-radius: var(--radius-sm);
  color: inherit;
  font: inherit;
  font-variant-numeric: var(--numeric);
  text-align: inherit;
  text-decoration: underline dotted var(--color-border-strong);
  text-underline-offset: 0.2em;
  white-space: nowrap;
  cursor: default;
}

.missing {
  color: var(--color-text-subtle);
}
